//imports
import {
    PARTNUMBERS_CREATE_EDIT_OPEN_MODAL,
    PARTNUMBERS_CREATE_REQUEST,
    PARTNUMBERS_CREATE_RESULT,
    PARTNUMBERS_UPDATE_REQUEST,
    PARTNUMBERS_UPDATE_RESULT,
    PARTNUMBERS_GET_REQUEST,
    PARTNUMBERS_GET_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    partnumber: null,
    current: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PARTNUMBERS_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, current: action.payload }

        case PARTNUMBERS_CREATE_REQUEST:
            return { ...state, loading: true }

        case PARTNUMBERS_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case PARTNUMBERS_UPDATE_REQUEST:
            return { ...state, loading: true }

        case PARTNUMBERS_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case PARTNUMBERS_GET_REQUEST:
            return { ...state, loading: true }

        case PARTNUMBERS_GET_RESULT:
            return { ...state, loading: false, partnumber: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_PARTNUMBERS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
